const StatsCard = ({ title, count, trend, trendText }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-600">{title}</p>
          <h3 className="text-3xl font-semibold mt-2">{count}</h3>
        </div>
        <div className={`p-3 rounded-full ${trend === 'up' ? 'bg-yellow-50' : 'bg-red-50'}`}>
          {/* You can add icons here */}
        </div>
      </div>
      <p className={`text-sm mt-2 ${trend === 'up' ? 'text-green-600' : 'text-red-600'}`}>
        {trend === 'up' ? '↑' : '↓'} {trendText}
      </p>
    </div>
  )
}

export default StatsCard;
